export default {
  nav: {
    logo_text: "Lễ hội Trái cây Đồng Tháp",
    home: "Trang chủ",
    products: "Sản phẩm",
    schedule: "Lịch hoạt động",
    change_language: "Thay đổi ngôn ngữ",
    organization: "Trung tâm chuyển đổi số tỉnh Đồng Tháp",
  },
  home: {
    banner: {
      annual_event: "Sự kiện thường niên 2026",
      title: "Hương Vị Đất Sen Hồng Kết Nối & Vươn Xa",
      description:
        "Tôn vinh giá trị nông sản và vẻ đẹp miệt vườn Đồng Tháp qua không gian lễ hội rực rỡ sắc màu trái cây đặc sản.",
      view_schedule: "Xem Lịch Sự Kiện",
      explore_products: "Khám Phá Sản Phẩm",
    },
    about: {
      subtitle: "GIỚI THIỆU LỄ HỘI",
      theme: "Chủ đề",
      time: "Thời gian",
      scale: "Quy mô",
      location: "Địa điểm",
    },
    products: {
      title: "Danh mục tiêu biểu",
      subtitle:
        "Thưởng thức hương vị ngọt lành từ những vùng chuyên canh trái cây lớn nhất xứ Sen Hồng.",
      dong_thap_specialty: "Đặc sản Đồng Tháp",
      specialty_fruit: "Trái cây đặc sản",
      ocop_dong_thap: "OCOP Đồng Tháp",
      view_all: "Xem tất cả sản phẩm",
    },
    schedule: {
      title: "Lịch Sự Kiện Nổi Bật",
      desc: "Những hoạt động đặc sắc trong khuôn khổ Lễ hội Trái cây Đồng Tháp 2026.",
      all_events: "Tất cả sự kiện",
      location: "Địa điểm",
      main_activity: "Hoạt động chính",
      focus: "Trọng tâm",
      host: "Chủ trì",
      delegates: "Đại biểu",
      advise: "Tham mưu",
      collaborate: "Phối hợp",
      cooperate: "Phối hợp",
      content: "Nội dung hoạt động chi tiết",
      detail_content: "Chi tiết nội dung",
      show_details: "Xem chi tiết",
      hide_details: "Thu gọn",
      supporting_activity: "Hoạt động hưởng ứng",
      response: "Hưởng ứng",
      day: "Ngày",
      month: "Tháng",
      host_unit: "Đơn vị chủ trì",
      cooperating_unit: "Đơn vị phối hợp",
      support_detail: "Chi tiết chương trình hưởng ứng",
    },
    tabs: {
      khungGio: "Lịch Theo Khung Giờ",
      xuyenSuot: "Hoạt Động Xuyên Suốt",
      chinh: "Hoạt Động Chính",
      huongUng: "Hoạt Động Hưởng Ứng",
    },
  },
  catalog: {
    lotus_land: "Đất Sen Hồng",
    title: "Danh mục Trái cây đặc sản",
    description:
      "Đồng Tháp – Vùng đất Sen Hồng nổi tiếng với những loại trái cây đặc sản mang hương vị phù sa màu mỡ. Chúng tôi tự hào giới thiệu hệ sinh thái trái cây đa dạng, đạt tiêu chuẩn chất lượng cao và chứng nhận quốc tế.",
    search_placeholder: "Tìm kiếm tên trái cây đặc sản...",
    loading: "Đang tải danh mục nông sản...",
    empty_message: "Không tìm thấy sản phẩm trái cây nào phù hợp với bộ lọc.",
    reset_filters: "Làm mới bộ lọc",
    certified: "Đã Chứng Nhận",
    growing_zone: "Mã vùng trồng",
    growing_zone_text: "Vùng trồng",
    view_detail: "Xem chi tiết",
    view_all: "Xem tất cả",
  },
  detail: {
    back_to_list: "Quay lại danh sách",
    specialty_category: "Danh mục trái cây đặc sản",
    certified_specialty: "Đã chứng nhận đặc sản",
    area: "Diện tích",
    yield: "Sản lượng",
    updating_images: "Đang cập nhật hình ảnh",
    bio_characteristics: "Đặc tính sinh học",
    char_desc: "Mô tả đặc tính",
    cert_protection: "Chứng nhận & Bảo hộ",
    qr_view_info: "Mã QR xem thông tin",
    traceability_code: "Mã số truy xuất",
    qr_desc: "Chia sẻ mã QR này để xem thông tin danh mục trái cây đặc sản",
    code_label: "Mã:",
    concentrated_area: "Vùng trồng tập trung",
    attached_documents: "Tài liệu đính kèm",
    click_to_enlarge: "Click để phóng to ảnh",
    orchard_photos: "Hình ảnh trái cây",
    orchard_photo: "Ảnh trái cây đặc sản",
    updating: "Đang cập nhật",
    export_market: "Thị trường xuất khẩu",
    market: "Thị trường",
    export_status: "Thông tin / Trạng thái",
    flag: "Hình ảnh cờ",
    infographic_title: "Thông tin trái cây",
    infographic_subtitle: "Hình ảnh trực quan của trái cây đặc sản",
    click_to_zoom: "Click để xem ảnh lớn",
    associated_businesses: "Doanh nghiệp liên kết",
    associated_businesses_subtitle: "Danh sách doanh nghiệp phân phối và cung cấp sản phẩm",
    cooperative_partner: "Hợp tác xã đối tác",
    directions: "Chi đường",
    contact: "Liên hệ",
  },
  schedule_page: {
    green_journey: "HÀNH TRÌNH XANH 2026",
    hero_title: "CHƯƠNG TRÌNH HOẠT ĐỘNG LỄ HỘI TRÁI CÂY ĐỒNG THÁP 2026",
    hero_desc:
      "Khám phá chuỗi sự kiện đặc sắc tôn vinh giá trị nông sản và văn hóa vùng đất Sen Hồng trong khuôn khổ lễ hội lớn nhất năm.",
    empty_state:
      "Đang cập nhật danh sách chương trình hoạt động cho phân mục này...",
    important: "Quan trọng",
    location: "Địa điểm",
    organizer: "Đơn vị chủ trì / Tham mưu",
    partner: "Phối hợp",
    scale: "Quy mô",
    concept: "Ý tưởng",
    format: "Hình thức",
    details: "Nội dung hoạt động chi tiết",
    ongoing_duration: "Suốt Lễ hội",
    all_day: "Cả ngày",
    update_error: "Lỗi khi tải danh sách hoạt động:",
    no_attachment: "Không tìm thấy tài liệu đính kèm cho hoạt động:",
    more_updates:
      "Tính năng đang tiếp tục được cập nhật thêm lịch từ Ban tổ chức.",
  },
};
